import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { ScanningModalComponent } from '@shared/components/scanning-modal/scanning-modal.component';
import { provideAngularQuery, QueryClient } from '@tanstack/angular-query-experimental';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ImageViewerModule } from './component/image-viewer/image-viewer/image-viewer.module';
import { ModalModule } from './component/modal/modal.module';
import { PaymentConfirmationComponent } from './component/payment-confirmation/payment-confirmation.component';
import { ReviewModule } from './component/review/review.module';
import { SaleModule } from './component/sale/sale.module';
import { AuthInterceptorService } from './interceptors/auth-interceptor.service';
import { ErrorInterceptorService } from './interceptors/error-interceptor.service';
import { RegisterSamlModalComponent } from './login/components/register-saml-modal/register-saml-modal.component';
import { PipesModule } from './pipes/pipes.module';

@NgModule({
  declarations: [AppComponent, PaymentConfirmationComponent, RegisterSamlModalComponent, ScanningModalComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ImageViewerModule,
    ReviewModule,
    ModalModule,
    SaleModule,
    BrowserAnimationsModule,
    PipesModule,
    ReactiveFormsModule,
  ],
  providers: [
    provideAngularQuery(new QueryClient()),
    InAppBrowser,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
